import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import React, { useLayoutEffect, useRef } from 'react'
import styled from 'styled-components'
import AboutDesc from './AboutDesc'
import { motion, useScroll, useTransform } from 'framer-motion'

const About = () => {

    const imgBox = useRef(null)
    const imgDiv = useRef(null)
    const AboutHead = useRef(null)
    const aboutBox = useRef(null)
    const aboutDiv = useRef(null)

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger)
        let mm = gsap.matchMedia();

        mm.add("(min-width: 740px)", () => {


            //* --> Image Pin
            ScrollTrigger.create(({
                trigger: imgBox.current,
                start: "top 30%",
                endTrigger: aboutDiv.current,
                end: "bottom bottom",
                pin: true,
            }))


            gsap.from('.mineImg', {
                scrollTrigger: {
                    trigger: imgDiv.current,
                    start: "0px bottom",
                    end: "bottom center",
                    scrub: 1,
                },
                rotationX: "-30deg",
                rotationY: "-30deg"
            })
        })

        return () => ScrollTrigger.getAll().forEach(t => t.kill());

    }, [])

    const { scrollYProgress } = useScroll({
        target: AboutHead,
        offset: ["start end", "start start"]
    })

    const scale = useTransform(scrollYProgress, [0, 0.9, 1], [0, 1.25, 0.5]);
    const opacity = useTransform(scrollYProgress, [0, 0.7, 1], [0, 1, 0]);

    return (
        <AboutBox className='container about' ref={aboutBox}>
            <AboutDiv className='AboutDiv' ref={AboutHead}>
                <motion.h1
                    style={{ scale, opacity }}
                    className="heading"> About Myself </motion.h1>
            </AboutDiv>

            <AboutInfo ref={aboutDiv} >

                <AboutImgBox ref={imgBox}>
                    <AboutImg ref={imgDiv} >
                        <img className='mineImg' src="/My/me.jpg" alt="" />
                    </AboutImg>
                </AboutImgBox>

                <AboutDesc />

                <AboutMoto className='moto'>
                    <em>'If you can dream it,  I can build it!' </em>
                </AboutMoto>

            </AboutInfo>
        </AboutBox>
    )
}

export default About

const AboutMoto = styled.div`

    align-self: center;
    text-align : center;
    em{
        font-size: 5rem;
        font-family: var(--font3);
        letter-spacing: 0.1rem;
        font-weight: 700;

        @media only screen and (max-width: 780px) {
            font-size: 3rem !important;
        }

        @media only screen and (max-width: 430px) {
            text-align:center;
        }
    }

`

const AboutImgBox = styled.div`
    height: inherit !important;
    width: 100% !important;

    @media only screen and (max-width: 740px) {
        display: flex;
        justify-content: center;
    }
`

const AboutImg = styled.div`
    width: 25rem;
    height: 25rem;
    overflow: hidden
    position: relative;
    transform-style: preserve-3d;

    @media only screen and (max-width: 1350px) {
        width: 20rem !important;
        height: 20rem !important;
    }

    @media only screen and (max-width: 960px) {
        width: 18rem !important;
        height: 18rem !important;
    }
    
    @media only screen and (max-width: 430px) {
        width: 15rem !important;
        height: 15rem !important;
    }
   

    img{

        width: 100%;
        height: 100%;
        object-fit:cover;
        border-radius: 1rem;
    }
`

const AboutInfo = styled.div`
    height: inherit !important;
    width: 100% !important;
    display: flex;
    flex-direction: column;
    gap: 20rem
`

const AboutDiv = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10rem;
    @media only screen and (max-width: 780px) {
        text-align: center; !important;
    }

    h1{
        text-transform: uppercase;
        font-family: vaR(--font1);
        font-size: 5rem;
        opacity:0;
        letter-spacing: 0.3rem; 

        @media only screen and (max-width: 570px) {
            font-size: 4rem; !important;
        }
    }
`

const AboutBox = styled.div`
        row-gap: 50vh;
        overflow: hidden;
        display: flex;
        padding: 2rem;
        flex-direction: column;
        min-height: 100vh;

        @media only screen and (max-width: 780px) {
            padding: 1rem !important;
        }
`